/**
 * @generated SignedSource<<42bac2db388419024513f43acf280c0f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "ID_ASC" | "ID_DESC" | "LATEST_UPDATE_DATE_ASC" | "LATEST_UPDATE_DATE_DESC" | "NAME_ASC" | "NAME_DESC" | "START_DATE_ASC" | "START_DATE_DESC" | "STATUS_ASC" | "STATUS_DESC" | "TARGET_DATE_ASC" | "TARGET_DATE_DESC" | "WATCHER_COUNT_ASC" | "WATCHER_COUNT_DESC" | "WATCHING_ASC" | "WATCHING_DESC";
export type DirectoryViewProjectQuery$variables = {
  after?: string | null;
  directoryViewUuid?: string | null;
  first?: number | null;
  includeContributors: boolean;
  includeFollowerCount: boolean;
  includeFollowing: boolean;
  includeGoals: boolean;
  includeLastUpdated: boolean;
  includeOwner: boolean;
  includeRelatedProjects: boolean;
  includeStartDate: boolean;
  includeStatus: boolean;
  includeTags: boolean;
  includeTargetDate: boolean;
  includeTeam: boolean;
  includedCustomFieldUuids?: ReadonlyArray<string> | null;
  isTableOrSavedView: boolean;
  isTimelineOrSavedView: boolean;
  skipTableTql: boolean;
  sort?: ReadonlyArray<ProjectSortEnum | null> | null;
  tql?: string | null;
  workspaceUuid: string;
};
export type DirectoryViewProjectQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryTableViewProject" | "ProjectTimeline">;
};
export type DirectoryViewProjectQuery = {
  response: DirectoryViewProjectQuery$data;
  variables: DirectoryViewProjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "directoryViewUuid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeContributors"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFollowerCount"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFollowing"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeGoals"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeLastUpdated"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOwner"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRelatedProjects"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeStartDate"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeStatus"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTags"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTargetDate"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTeam"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includedCustomFieldUuids"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTableOrSavedView"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTimelineOrSavedView"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipTableTql"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tql"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v22 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v23 = {
  "kind": "Variable",
  "name": "directoryViewUuid",
  "variableName": "directoryViewUuid"
},
v24 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v25 = {
  "kind": "Variable",
  "name": "includedCustomFieldUuids",
  "variableName": "includedCustomFieldUuids"
},
v26 = {
  "kind": "Variable",
  "name": "sort",
  "variableName": "sort"
},
v27 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v28 = [
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "tql"
  },
  (v26/*: any*/),
  (v27/*: any*/)
],
v29 = {
  "kind": "ScalarField",
  "name": "id"
},
v30 = {
  "kind": "ScalarField",
  "name": "count"
},
v31 = {
  "kind": "ScalarField",
  "name": "name"
},
v32 = {
  "kind": "ScalarField",
  "name": "private"
},
v33 = [
  (v31/*: any*/)
],
v34 = {
  "kind": "ScalarField",
  "name": "key"
},
v35 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v36 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v29/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v39 = [
  {
    "kind": "ScalarField",
    "name": "canSetMultipleValues"
  }
],
v40 = {
  "kind": "ScalarField",
  "name": "value"
},
v41 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v42 = {
  "kind": "ScalarField",
  "name": "picture"
},
v43 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v31/*: any*/),
    (v42/*: any*/)
  ]
},
v44 = {
  "kind": "ScalarField",
  "name": "label"
},
v45 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v46 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v45/*: any*/)
},
v47 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v48 = [
  (v40/*: any*/),
  (v44/*: any*/),
  (v46/*: any*/)
],
v49 = {
  "kind": "ScalarField",
  "name": "watcherCount"
},
v50 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v51 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v52 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DirectoryViewProjectQuery",
    "selections": [
      {
        "condition": "isTableOrSavedView",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "kind": "Variable",
                "name": "includeContributors",
                "variableName": "includeContributors"
              },
              {
                "kind": "Variable",
                "name": "includeFollowerCount",
                "variableName": "includeFollowerCount"
              },
              {
                "kind": "Variable",
                "name": "includeFollowing",
                "variableName": "includeFollowing"
              },
              {
                "kind": "Variable",
                "name": "includeGoals",
                "variableName": "includeGoals"
              },
              {
                "kind": "Variable",
                "name": "includeLastUpdated",
                "variableName": "includeLastUpdated"
              },
              {
                "kind": "Variable",
                "name": "includeOwner",
                "variableName": "includeOwner"
              },
              {
                "kind": "Variable",
                "name": "includeRelatedProjects",
                "variableName": "includeRelatedProjects"
              },
              {
                "kind": "Variable",
                "name": "includeStartDate",
                "variableName": "includeStartDate"
              },
              {
                "kind": "Variable",
                "name": "includeStatus",
                "variableName": "includeStatus"
              },
              {
                "kind": "Variable",
                "name": "includeTags",
                "variableName": "includeTags"
              },
              {
                "kind": "Variable",
                "name": "includeTargetDate",
                "variableName": "includeTargetDate"
              },
              {
                "kind": "Variable",
                "name": "includeTeam",
                "variableName": "includeTeam"
              },
              (v25/*: any*/),
              {
                "kind": "Variable",
                "name": "skipTableTql",
                "variableName": "skipTableTql"
              },
              (v26/*: any*/),
              {
                "kind": "Variable",
                "name": "tql",
                "variableName": "tql"
              },
              (v27/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "DirectoryTableViewProject"
          }
        ]
      },
      {
        "condition": "isTimelineOrSavedView",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v28/*: any*/),
            "kind": "FragmentSpread",
            "name": "ProjectTimeline"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v20/*: any*/),
      (v1/*: any*/),
      (v21/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v19/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v6/*: any*/),
      (v12/*: any*/),
      (v10/*: any*/),
      (v15/*: any*/),
      (v18/*: any*/)
    ],
    "kind": "Operation",
    "name": "DirectoryViewProjectQuery",
    "selections": [
      {
        "condition": "isTableOrSavedView",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "concreteType": "UserPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "wrapTextEnabled"
                  },
                  (v29/*: any*/)
                ]
              },
              (v29/*: any*/)
            ]
          },
          {
            "condition": "skipTableTql",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v28/*: any*/),
                "concreteType": "ProjectConnection",
                "kind": "LinkedField",
                "name": "projectTql",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  {
                    "concreteType": "ProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "ari"
                          },
                          (v31/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "archived"
                          },
                          (v32/*: any*/),
                          {
                            "concreteType": "ManagerDataResponse",
                            "kind": "LinkedField",
                            "name": "managerData",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "ManagerData",
                                "kind": "LinkedField",
                                "name": "managers",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "UserPII",
                                    "kind": "LinkedField",
                                    "name": "managerProfile",
                                    "plural": false,
                                    "selections": (v33/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "directReports"
                                  }
                                ]
                              }
                            ]
                          },
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          {
                            "args": [
                              (v25/*: any*/)
                            ],
                            "concreteType": "CustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CustomFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v37/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "definition",
                                            "plural": false,
                                            "selections": [
                                              (v37/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v35/*: any*/)
                                                ],
                                                "type": "CustomFieldDefinitionNode",
                                                "abstractKey": "__isCustomFieldDefinitionNode"
                                              },
                                              (v38/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "CustomFieldNode",
                                        "abstractKey": "__isCustomFieldNode"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "CustomFieldNumberSavedValueNode",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": "numberValue",
                                                "kind": "ScalarField",
                                                "name": "value"
                                              },
                                              (v29/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "NumberCustomField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "definition",
                                            "plural": false,
                                            "selections": [
                                              (v37/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v39/*: any*/),
                                                "type": "TextSelectCustomFieldDefinition"
                                              },
                                              (v38/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "CustomFieldTextSavedValueConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              (v30/*: any*/),
                                              {
                                                "concreteType": "CustomFieldTextSavedValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "CustomFieldTextSavedValueNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v29/*: any*/),
                                                      (v40/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "TextSelectCustomField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "definition",
                                            "plural": false,
                                            "selections": [
                                              (v37/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v39/*: any*/),
                                                "type": "UserCustomFieldDefinition"
                                              },
                                              (v38/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "UserConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              (v30/*: any*/),
                                              {
                                                "concreteType": "UserEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "User",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v43/*: any*/),
                                                      (v29/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "UserCustomField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "CustomFieldTextSavedValueNode",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": "textValue",
                                                "kind": "ScalarField",
                                                "name": "value"
                                              },
                                              (v29/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "TextCustomField"
                                      },
                                      (v38/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v37/*: any*/),
                          {
                            "condition": "includeLastUpdated",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "latestUpdateDate"
                              }
                            ]
                          },
                          {
                            "condition": "includeFollowing",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "watching"
                              },
                              {
                                "concreteType": "TownsquareProjectCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchProject"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "includeContributors",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "ContributorConnection",
                                "kind": "LinkedField",
                                "name": "contributors",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "ContributorEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v37/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v43/*: any*/)
                                            ],
                                            "type": "User"
                                          },
                                          (v38/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "includeTargetDate",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "TargetDate",
                                "kind": "LinkedField",
                                "name": "dueDate",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                  },
                                  (v44/*: any*/),
                                  (v46/*: any*/),
                                  {
                                    "alias": "tooltip",
                                    "args": (v47/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": "label(longFormat:true)"
                                  },
                                  {
                                    "alias": "localizedTooltip",
                                    "args": (v47/*: any*/),
                                    "concreteType": "LocalizationField",
                                    "kind": "LinkedField",
                                    "name": "localizedLabel",
                                    "plural": false,
                                    "selections": (v45/*: any*/),
                                    "storageKey": "localizedLabel(longFormat:true)"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "overdue"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "includeStatus",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "ProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                  (v44/*: any*/),
                                  (v46/*: any*/),
                                  (v40/*: any*/),
                                  {
                                    "concreteType": "CompletionProjectState",
                                    "kind": "LinkedField",
                                    "name": "atCompletionState",
                                    "plural": false,
                                    "selections": (v48/*: any*/)
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "includeOwner",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "aaid"
                                  },
                                  {
                                    "concreteType": "UserPII",
                                    "kind": "LinkedField",
                                    "name": "pii",
                                    "plural": false,
                                    "selections": [
                                      (v42/*: any*/),
                                      (v41/*: any*/)
                                    ]
                                  },
                                  (v29/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "includeRelatedProjects",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "ProjectDependencyConnection",
                                "kind": "LinkedField",
                                "name": "dependencies",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "concreteType": "ProjectDependencyEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "ProjectDependency",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "Project",
                                            "kind": "LinkedField",
                                            "name": "outgoingProject",
                                            "plural": false,
                                            "selections": [
                                              (v29/*: any*/),
                                              (v34/*: any*/),
                                              (v31/*: any*/),
                                              (v35/*: any*/),
                                              (v32/*: any*/),
                                              (v36/*: any*/)
                                            ]
                                          },
                                          (v29/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "includeTeam",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "TeamConnection",
                                "kind": "LinkedField",
                                "name": "teams",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TeamEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "Team",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "avatarUrl"
                                          },
                                          (v31/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "teamId"
                                          },
                                          (v29/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v30/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "includeGoals",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "GoalConnection",
                                "kind": "LinkedField",
                                "name": "goals",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "concreteType": "GoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "Goal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          (v35/*: any*/),
                                          (v34/*: any*/),
                                          {
                                            "concreteType": "GoalIcon",
                                            "kind": "LinkedField",
                                            "name": "icon",
                                            "plural": false,
                                            "selections": [
                                              (v34/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "appearance"
                                              }
                                            ]
                                          },
                                          (v31/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "includeTags",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "TagConnection",
                                "kind": "LinkedField",
                                "name": "tags",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "Tag",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          (v31/*: any*/),
                                          (v35/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "description"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "projectUsageCount"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "goalUsageCount"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "helpPointerUsageCount"
                                          },
                                          (v49/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v30/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "includeFollowerCount",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v49/*: any*/)
                            ]
                          },
                          {
                            "condition": "includeStartDate",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v50/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v51/*: any*/)
                    ]
                  },
                  (v52/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v28/*: any*/),
                "filters": [
                  "q",
                  "workspaceUuid",
                  "directoryViewUuid",
                  "sort"
                ],
                "handle": "connection",
                "key": "DirectoryTable__projectTql",
                "kind": "LinkedHandle",
                "name": "projectTql"
              }
            ]
          }
        ]
      },
      {
        "condition": "isTimelineOrSavedView",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "projectTimeline",
            "args": (v28/*: any*/),
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projectTql",
            "plural": false,
            "selections": [
              (v30/*: any*/),
              {
                "concreteType": "ProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Project",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v50/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "creationDate"
                      },
                      {
                        "concreteType": "ProjectState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": (v48/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "targetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "targetDateConfidence"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "targetDateSet"
                      },
                      (v29/*: any*/),
                      (v34/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v36/*: any*/),
                      {
                        "concreteType": "ProjectPhaseDetails",
                        "kind": "LinkedField",
                        "name": "newPhase",
                        "plural": false,
                        "selections": (v33/*: any*/)
                      },
                      (v37/*: any*/)
                    ]
                  },
                  (v51/*: any*/)
                ]
              },
              (v52/*: any*/)
            ]
          },
          {
            "alias": "projectTimeline",
            "args": (v28/*: any*/),
            "filters": [
              "workspaceUuid",
              "q",
              "directoryViewUuid",
              "sort"
            ],
            "handle": "connection",
            "key": "ProjectTimeline__projectTimeline",
            "kind": "LinkedHandle",
            "name": "projectTql"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "07463a16b88865dec2686ba8a6e9377f",
    "id": null,
    "metadata": {},
    "name": "DirectoryViewProjectQuery",
    "operationKind": "query",
    "text": "query DirectoryViewProjectQuery(\n  $tql: String\n  $directoryViewUuid: UUID\n  $workspaceUuid: UUID!\n  $after: String\n  $first: Int\n  $sort: [ProjectSortEnum]\n  $isTableOrSavedView: Boolean!\n  $isTimelineOrSavedView: Boolean!\n  $includeContributors: Boolean!\n  $includeFollowerCount: Boolean!\n  $includeFollowing: Boolean!\n  $includeLastUpdated: Boolean!\n  $includeOwner: Boolean!\n  $includeRelatedProjects: Boolean!\n  $includeStatus: Boolean!\n  $includeTargetDate: Boolean!\n  $includeTeam: Boolean!\n  $includeGoals: Boolean!\n  $includeTags: Boolean!\n  $includeStartDate: Boolean!\n  $includedCustomFieldUuids: [UUID!]\n  $skipTableTql: Boolean!\n) {\n  ...DirectoryTableViewProject_15M8p1 @include(if: $isTableOrSavedView)\n  ...ProjectTimeline_3Zp2r6 @include(if: $isTimelineOrSavedView)\n}\n\nfragment ContributorsColumn on ContributorConnection {\n  edges {\n    node {\n      __typename\n      ... on User {\n        pii {\n          accountId\n          name\n          picture\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment CustomFieldCell on CustomFieldConnection {\n  edges {\n    node {\n      __typename\n      ... on CustomFieldNode {\n        __isCustomFieldNode: __typename\n        definition {\n          __typename\n          ... on CustomFieldDefinitionNode {\n            __isCustomFieldDefinitionNode: __typename\n            uuid\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n      ...NumberFieldColumn\n      ...TextSelectFieldColumn\n      ...UserFieldColumn\n      ...TextFieldColumn\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment DirectoryRowProject_3LjlDU on Project {\n  latestUpdateDate @include(if: $includeLastUpdated)\n  ...ProjectActions\n  ...ProjectNameColumn\n  ...ProjectFollowButton @include(if: $includeFollowing)\n  contributors @include(if: $includeContributors) {\n    ...ContributorsColumn\n  }\n  dueDate @include(if: $includeTargetDate) {\n    ...TargetDate\n  }\n  state @include(if: $includeStatus) {\n    ...ProjectState\n  }\n  owner @include(if: $includeOwner) {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  dependencies @include(if: $includeRelatedProjects) {\n    ...RelatedProjects\n  }\n  teams @include(if: $includeTeam) {\n    ...TeamOfProject\n  }\n  goals @include(if: $includeGoals) {\n    ...ProjectGoals\n  }\n  tags @include(if: $includeTags) {\n    ...TagColumn\n  }\n  ...FollowerCount_project @include(if: $includeFollowerCount)\n  startDate @include(if: $includeStartDate)\n  customFields(includedCustomFieldUuids: $includedCustomFieldUuids) {\n    ...CustomFieldCell\n  }\n}\n\nfragment DirectoryTableViewProject_15M8p1 on Query {\n  projectTql(first: $first, after: $after, q: $tql, workspaceUuid: $workspaceUuid, directoryViewUuid: $directoryViewUuid, sort: $sort) @skip(if: $skipTableTql) {\n    count\n    edges {\n      node {\n        id\n        ...DirectoryRowProject_3LjlDU\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  currentUser {\n    preferences {\n      wrapTextEnabled\n      id\n    }\n    id\n  }\n}\n\nfragment FollowerCount_project on Project {\n  key\n  ...ProjectFollowersButton\n}\n\nfragment GoalEntry on Goal {\n  ...GoalName\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment NumberFieldColumn on NumberCustomField {\n  value {\n    numberValue: value\n    id\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectActions on Project {\n  id\n  ari\n  name\n  archived\n  private\n}\n\nfragment ProjectBar on Project {\n  startDate\n  creationDate\n  state {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n  targetDate\n  targetDateConfidence\n  targetDateSet\n  ...ProjectName_data\n  ...utilsGetProjectTargetEndDate\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchProject\n  }\n}\n\nfragment ProjectFollowersButton on Project {\n  key\n  watcherCount\n}\n\nfragment ProjectGoals on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalEntry\n    }\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectNameColumn on Project {\n  managerData {\n    managers {\n      managerProfile {\n        name\n      }\n      directReports\n    }\n  }\n  ...ProjectName_data\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectTimeline_3Zp2r6 on Query {\n  projectTimeline: projectTql(first: $first, after: $after, workspaceUuid: $workspaceUuid, q: $tql, directoryViewUuid: $directoryViewUuid, sort: $sort) {\n    count\n    edges {\n      node {\n        uuid\n        startDate\n        creationDate\n        ...ProjectBar\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RelatedProjects on ProjectDependencyConnection {\n  count\n  edges {\n    node {\n      outgoingProject {\n        ...ProjectName_data\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment TagColumn on TagConnection {\n  edges {\n    node {\n      ...Tag\n      id\n    }\n  }\n  count\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment TeamOfProject on TeamConnection {\n  edges {\n    node {\n      avatarUrl\n      name\n      teamId\n      id\n    }\n  }\n  count\n}\n\nfragment TextFieldColumn on TextCustomField {\n  value {\n    textValue: value\n    id\n  }\n}\n\nfragment TextSelectFieldColumn on TextSelectCustomField {\n  definition {\n    __typename\n    ... on TextSelectCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    count\n    edges {\n      node {\n        id\n        value\n      }\n    }\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserFieldColumn on UserCustomField {\n  definition {\n    __typename\n    ... on UserCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    count\n    edges {\n      node {\n        pii {\n          accountId\n          name\n          picture\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment utilsGetProjectTargetEndDate on Project {\n  newPhase {\n    name\n  }\n  startDate\n  creationDate\n  targetDate\n  targetDateConfidence\n  targetDateSet\n}\n"
  }
};
})();

(node as any).hash = "d560a144a321c285470bd6cacbb0acfe";

export default node;
